module.exports = __webpack_public_path__ + "static/media/covid-19-map.41f8ccd9.jpg";